import React from "react";
import {greyishBlue50} from "assets/jss/main";
import {getTranslation} from "../../../../../../../helpers/translations";

export default function SelectedProductsList({selected}) {
    return (
        <div style={{
            padding: '12px',
            backgroundColor: greyishBlue50,
            fontSize: '12px',
            color: '#7c838f',
            marginTop: '12px'
        }}>
            {selected.slice(0, 5).map((product) => (
                <div key={product.id || product.sku}>
                    {`${getTranslation(product).name} (${product.sku})`}
                </div>
            ))}
            {selected.length > 5 && (
                <div style={{marginTop: '4px'}}>...</div>
            )}
        </div>
    );
}
